<template>
	<div>
        <compWrapper title="详情" theme="primary">
            <compFormQuery
                :col="1"
                v-if="type=='query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
            >
            </compFormQuery>
            <div class="text-right" >
                <vButton v-if="this.formData.status==1" theme="primary" class="margin-right-20" @click="check">检测重复注册</vButton>
                <vButton v-if="this.formData.status==1" theme="success" class="margin-right-20" @click="showModal('accept')">审批通过</vButton>
                <vButton v-if="this.formData.status==1" theme="default" class="margin-right-20" @click="showModal('pass')">审批忽略</vButton>
                <vButton v-if="this.formData.status==1" theme="error" class="margin-right-20" @click="showModal('denied')">审批拒回</vButton>
                <vButton theme="primary" class="margin-right-20" @click="back">返回</vButton>
            </div>
        </compWrapper>
        <Modal
            v-model="modalTip"
            :title="title"
            @on-ok="approve(title)"
            @on-cancel="modalTip = false">
            <p>{{content}}</p>
        </Modal>
    </div>
</template>
<script>
import {HttpLoadData,HttpCheckIdVectorExists,HttpAccept,HttpBypass,HttpDenied} from "@/service/ucadm";
export default {
	components: {
        // compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit")
    },
    data() {
        return {
            id: this.$route.query.id,
            type: this.$route.params.type,
            formData:{
                userName:"",
                userLoginEmail:"",
                userLoginPhone:"",
                companyName:"",
                companyAddress:"",
                extraInfo:"",
                status:"",
                createdAt:"",
                updatedAt:"",
            },
            styWidth: 110,
            status:{},
            content:"",
            title:"",
            modalTip:false
        }
    },
    created() {
        console.log(this.type)
        if (this.type == "query" || this.type == "edit") {
            this.getDetail();
        }
    },
    computed: {
        getBase() {
            return [
                {
                    label: "审批状态",
                    key: "status",
                    props: {},
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                    span:12,
                    required: true,
                    render: h => {
                        let status = this.getStatusMap(this.formData.status);
                        let statusEle = <tag color={status.tag.color}>{status.name}</tag>;
                        return statusEle;
                    },
                },
                {
                    label: "名称",
                    key: "userName",
                    props: {},
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                    span:12,
                    required: true
                },
                {
                    label: "邮箱",
                    key: "userLoginEmail",
                    props: {},
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                    span:12,
                    required: true
                },
                {
                    label: "电话",
                    key: "userLoginPhone",
                    props: {},
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                    span:12,
                    required: true
                },
                {
                    label: "组织名称",
                    key: "orgName",
                    props: {},
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                    span:12,
                    required: true
                },
                {
                    label: "公司地址",
                    key: "companyAddress",
                    props: {},
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                    span:12,
                    required: true
                },
                {
                    label: "日预估单量",
                    key: "orgName",
                    props: {},
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                    span:12,
                    required: true,
                    render: (h) => { 
                        var dailyOrderAvg = JSON.parse(this.formData.extraInfo);
                        return dailyOrderAvg.dailyOrderAvg
                    }
                },
            ]
        }
    },
    methods: {
        getStatusMap(state) {
            let statusMap = {
                0: {
                    "name": this.$t('uc.registration_status.unspecified',{defaultValue:'未明确'}),
                    "label": "unspecified",
                    "tag": {
                        "color":"default"
                    }
                },
                1: {
                    "name": this.$t('uc.registration_status.committed',{defaultValue:'待审核'}),
                    "label": "committed",
                    "tag": {
                        "color":"warning"
                    }
                },
                2: {
                    "name": this.$t('uc.registration_status.denied',{defaultValue:'审批拒回'}),
                    "label": "denied",
                    "tag": {
                        "color":"error"
                    }
                },
                3: {
                    "name": this.$t('uc.registration_status.accept',{defaultValue:'审批同意'}),
                    "label": "accept",
                    "tag": {
                        "color":"success"
                    }
                },
                4: {
                    "name": this.$t('uc.registration_status.assigned',{defaultValue:'审批通过'}),
                    "label": "assigned",
                    "tag": {
                        "color":"success"
                    }
                },
                5: {
                    "name": this.$t('uc.registration_status.bypass',{defaultValue:'审批忽略'}),
                    "label": "bypass",
                    "tag": {
                        "color":"default"
                    }
                }
            };
            return statusMap[state];
        },
        getDetail() {
            this.loading = true;
            HttpLoadData({
                id: this.id
            })
            .then(
                res => {
                    console.log(res.data)
                    this.handleResponse(res.data);
                },
                err => {
                    this.$Message.error(err.message);
                }
            )
            .finally(res => {
                this.loading = false;
            });
        },
        handleResponse(data = {}) {
            this.status = data.statusEnumDict;
            this.formData = data.entity;
            console.log(data)
        },
        check(){
            HttpCheckIdVectorExists({
                id: this.id
            })
            .then(
                res => {
                    this.$Message.success(res.message);
                },
                err => {
                    this.$Message.error(err.message);
                }
            )
        },
        showModal(type){
            this.modalTip = true;
            if(type == "accept"){
                this.title="是否通过该审批"
                this.content = "确定 是否通过该审批?"
            }else if(type == "pass"){
                this.title="是否忽略该审批"
                this.content = "确定 是否忽略该审批?"
            }else if(type == "denied"){
                this.title="是否拒回该审批"
                this.content = "确定 是否拒回该审批?"
            }
        },
        approve(type){
            if(type.indexOf('通过') != -1){
                HttpAccept({
                    id: this.id
                })
                .then(
                    res => {
                        this.$Message.success(res.message);
                        this.back()
                    },
                    err => {
                        this.$Message.error(err.message);
                    }
                )
            }else if(type.indexOf('忽略') != -1){
                HttpBypass({
                    id: this.id
                })
                .then(
                    res => {
                        this.$Message.success(res.message);
                        this.back()
                    },
                    err => {
                        this.$Message.error(err.message);
                    }
                )
            }else if(type.indexOf('拒回') != -1){
                HttpDenied({
                    id: this.id
                })
                .then(
                    res => {
                        this.$Message.success(res.message);
                        this.back()
                    },
                    err => {
                        this.$Message.error(err.message);
                    }
                )
            }
        },
        back(){
            this.$router.push({
				name: 'registrationmanage',
			});
        }
    }
}
</script>